module.exports = __webpack_public_path__ + "media/82.4afd2912.wav";